"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBasicCooperativeVariants = void 0;
const routes_1 = require("../../routes");
const getBasicCooperativeVariants = (client) => async (params, query) => {
    const response = await client.get(routes_1.ENDPOINTS.GET_ALL_BASIC_COOPERATIVE_VARIANTS.applyParams(params), {
        params: {
            invivo_ids: query.invivo_ids.join(','),
        },
    });
    return response.data;
};
exports.getBasicCooperativeVariants = getBasicCooperativeVariants;
